import script from "./FormSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSection.vue?vue&type=script&setup=true&lang=js"

import "./FormSection.vue?vue&type=style&index=0&id=e4bd0020&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4bd0020"]])

export default __exports__